import React from "react";

const Header = ({ title }) => {
  return (
    <div>
      <div className="ui header" style={{ color: "#3E92D0" }}>
        <h1>{title}</h1>
      </div>
    </div>
  );
};

export default Header;
